import script from "./MessageBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageBtn.vue?vue&type=script&lang=ts&setup=true"

import "./MessageBtn.vue?vue&type=style&index=0&id=6b012424&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b012424"]])

export default __exports__